import { useRef } from "react";

import {
  Container,
  ActiveMenu,
  ActivedButtonContainer,
  MenuNone,
  MenuText,
  MenuCheck,
  MenuOption,
  MenuUnmarked,
} from "./styles";
import Filter from "../../../assets/icons/Filter";
import Check from "../../../assets/icons/Check";
import Button from "../../../components/general/Button/index";
import { useOutsideDrop } from "../../../hooks/useOutsideDrop";

export const FilterButton = ({
  open,
  setOpen,
  type,
  setType,
  urlParams = null,
}) => {
  const containerRef = useRef(null);

  useOutsideDrop(containerRef, () => {
    setOpen(false);
  });

  return (
    <>
      {!open ? (
        <Container>
          <Button
            Icon={() => <Filter />}
            onClick={(e) => {
              setOpen(!open);
              e.stopPropagation();
            }}
            content="Filtros"
          />
        </Container>
      ) : (
        <ActivedButtonContainer ref={containerRef}>
          <Button
            colorText="#7e858f"
            Icon={() => <Filter />}
            onClick={() => {
              setOpen(!open);
            }}
            content="Filtros"
            greenBase
          />
          <ActiveMenu>
            <MenuNone
              onClick={() => {
                if (!(!type.alpha && !type.creation))
                  setType({ ...type, alpha: false, creation: false });
              }}
            >
              <MenuText>Nenhum</MenuText>
              <MenuCheck>
                {!type.alpha && !type.creation ? (
                  <Check height={"1rem"} />
                ) : (
                  <MenuUnmarked />
                )}
              </MenuCheck>
            </MenuNone>
            <MenuOption
              onClick={() => {
                if (!(type.alpha && !type.creation))
                  setType({ ...type, alpha: true, creation: false });
              }}
            >
              <MenuText>Ordem Alfabética</MenuText>
              <MenuCheck>
                {type.alpha ? <Check height={"1rem"} /> : <MenuUnmarked />}
              </MenuCheck>
            </MenuOption>
            <MenuOption
              onClick={() => {
                if (!(!type.alpha && type.creation))
                  setType({ ...type, alpha: false, creation: true });
              }}
            >
              <MenuText>Ordem de Criação</MenuText>
              <MenuCheck>
                {type.creation ? <Check height={"1rem"} /> : <MenuUnmarked />}
              </MenuCheck>
            </MenuOption>
          </ActiveMenu>
        </ActivedButtonContainer>
      )}
    </>
  );
};
